import { LeftOutlined } from "@ant-design/icons";
import type { FC } from "react";

import { usePageTitle } from "../../CommonComponents/Layout/PageTitleContext";

import styles from "./WizardPageHeader.module.css";

export type WizardPageHeaderProps = {
  title: string;
  /** Accessible label for the back arrow (the icon has no visible text). */
  backAriaLabel: string;
  onBack: () => void;
  backTestId?: string;
};

/**
 * Shared Game Pass wizard page header: registers the layout title and renders
 * the back affordance used by Create Season and Create Monthly Challenge.
 */
const WizardPageHeader: FC<WizardPageHeaderProps> = ({
  title,
  backAriaLabel,
  onBack,
  backTestId,
}) => {
  usePageTitle(title);

  return (
    <div className={styles.header}>
      <button
        type="button"
        className={styles.backButton}
        aria-label={backAriaLabel}
        onClick={onBack}
        data-testid={backTestId}
      >
        <LeftOutlined className={styles.backButtonIcon} />
      </button>
    </div>
  );
};

export default WizardPageHeader;
